module.exports = __webpack_public_path__ + "static/media/royce2.53e11a2e.jpeg";